export default __webpack_public_path__ + "static/media/ourclient10.93256728.png";